import { cn } from "@/lib/utils";

export const LaunchHeader = ({
  name,
  logo,
  subtitle = "Launch your app",
  className
}: {
  name?: string;
  logo?: string;
  subtitle?: string;
  className?: string;
}) => (
  <div className={cn("flex items-center gap-3", className)}>
    <img
      src={logo}
      alt={name}
      className="size-12 rounded-lg border bg-background object-contain p-1"
    />
    <div className="flex flex-col">
      <h1 className="text-xl font-bold leading-tight">{name}</h1>
      <p className="text-sm text-muted-foreground">{subtitle}</p>
    </div>
  </div>
);
